<template>
  <div class="container">
    <a-modal title="固定资产-详情" :visible="detailsvisible" @cancel="detailsCancel" width="880px">
			<template slot="footer">
				<a-button key="back" @click="detailsCancel"> 取消 </a-button>
			</template>
			<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="资产类别" class="form_item" >
								<span>{{ detailsrow.asset_type ? goodsTypeObj[detailsrow.asset_type] : '' }}</span>
				        </a-form-model-item>
					</a-col>
                    <a-col :span="12">
						<a-form-model-item label="品类名称" class="form_item">
					       <span>{{  detailsrow.category_name }}</span>
				        </a-form-model-item>
					</a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="物品编号" class="form_item">
					         <span>{{ detailsrow.asset_sn }}</span>
				        </a-form-model-item>
					</a-col>
                    <a-col :span="12">
						<a-form-model-item label="物品名称" class="form_item">
					        <span>{{ detailsrow.name }}</span>
				        </a-form-model-item>
					</a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="物品单位" class="form_item">
					        <span>{{ detailsrow.unit }}</span>
				        </a-form-model-item>
					</a-col>
                    <a-col :span="12">
                        <a-form-model-item label="物品状态" class="form_item">
				         	<span>{{ detailsrow.state ? statusMap6[detailsrow.state] : '' }}</span>
			         	</a-form-model-item>
					</a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
						<a-form-model-item label="规格型号" class="form_item">
					        <span>{{ detailsrow.model }}</span>
				        </a-form-model-item>
					</a-col>
                    <a-col :span="12">
						<a-form-model-item label="采购时间" class="form_item">
					        <span>{{ detailsrow.purchase_time }}</span>
				        </a-form-model-item>
					</a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
						<a-form-model-item label="采购价格" class="form_item">
					        <span>{{ detailsrow.purchase_price }}</span>
				        </a-form-model-item>
					</a-col>
                    <a-col :span="12">
						<a-form-model-item label="责任部门" class="form_item">
					       <span>{{ detailsrow.dept_id ? deptMap[detailsrow.dept_id].title : '' }}</span>
				        </a-form-model-item>
					</a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
						<a-form-model-item label="当前估值" class="form_item">
					        <span>{{ detailsrow.value }}</span>
				        </a-form-model-item>
					</a-col>
                    <a-col :span="12">
						<a-form-model-item label="责 任 人 " class="form_item">
				            <span>{{ detailsrow.charger }}</span>
				        </a-form-model-item>
					</a-col>
				</a-row>
				 <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="入 库 人 " class="form_item">
					         <span>{{ detailsrow.operator }}</span>
				        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="保 管 人 " class="form_item">
					         <span>{{ detailsrow.keeper }}</span>
				        </a-form-model-item>
                	</a-col>
				</a-row>
				<a-row>
                    <a-col :span="12">
                        <a-form-model-item label="到货日期" class="form_item">
					        <span>{{ detailsrow.arrive_time }}</span>
				        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="存放位置" class="form_item">
					        <span>{{ detailsrow.storage_loc }}</span>
				        </a-form-model-item>
                    </a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="作业条件" class="form_item">
					        <span>{{ detailsrow.storage_cond }}</span>
				        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="供 应 商 " class="form_item">
					        <span>{{ detailsrow.dealer }}</span>
				        </a-form-model-item>
                    </a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="生产厂家" class="form_item">
				         	<span>{{ detailsrow.manufacturer }}</span>
				        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="出厂编号" class="form_item">
					        <span>{{ detailsrow.factory_sn }}</span>
				        </a-form-model-item>
                    </a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="是否检定" class="form_item">
					       <span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
				         </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="检定周期" class="form_item">
					       <span>{{ detailsrow.inspect_cycle }}</span>
				        </a-form-model-item>
                    </a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="检定日期" class="form_item">
					        <span>{{ detailsrow.inspect_time }}</span>
				        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="仪器精度" class="form_item">
					        <span>{{ detailsrow.precisions }}</span>
				        </a-form-model-item>
                    </a-col>
				</a-row>
				<a-row>
                    <a-col :span="12">
                        <a-form-model-item label="检定结果" class="form_item">
					        <span>{{ detailsrow.inspect_result }}</span>
				        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="准用说明" class="form_item">
					        <span>{{ detailsrow.permit }}</span>
				        </a-form-model-item>
                    </a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="录 入 人 " class="form_item">
					        <span>{{ detailsrow.create_by }}</span>
				        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="录入时间" class="form_item">
					        <span>{{ detailsrow.create_time }}</span>
				        </a-form-model-item>
                    </a-col>
				</a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="维 护 人 " class="form_item">
					        <span>{{ detailsrow.update_by }}</span>
				        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="维护时间" class="form_item">
					        <span>{{ detailsrow.update_time }}</span>
				        </a-form-model-item>
                    </a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="备注信息" class="form_item">
					     <span>{{ detailsrow.notes }}</span>
			         	</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品图片">
							<div class="view_path_img" v-for="(item, index) in detailsrow.pic_path_list" :key="index"
								style="display: flex; justify-content: space-between">
								<div class="view_path_img_margin"></div>
								<div class="view_path_img_center">
									<img :src="item" @click="show_img(index, detailsrow.pic_path_list)" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
							<a-form-model-item label="附件信息">
							<div class="view_path" @click="previewFile(item)"
								v-for="(item, index) in detailsrow.att_paths" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					 </a-col>
					<a-col :span="12">
						<a-form-model-item label="证书信息">
							<div class="view_path" @click="previewFile(item)"
								v-for="(item, index) in detailsrow.cert_paths" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<preview ref="preview"></preview>

  </div>
</template>

<script>
import preview from '@/components/module/prview'
import { statusMap } from '@/api/activiti'
import {  enableParent } from '@/api/purchase'
// import { limitCompany } from '@/utils/limitCompany'
// import {getDeptListEnable2} from '@/api/system'
export default {
	 components: {
      preview,
    },
    data() {
        return {
            statusMap,
			deptMap: [],
            detailsvisible: false,
            detailsrow: [],
            labelCol: {
					span: 6,
				},
			wrapperCol: {
					span: 18,
				},
        }
    },
    methods: {
		 show_img(idx, imgs) {
      var arr = []
      for (var i = 0; i < imgs.length; i++) {
        arr[i] = {
          preUrl: imgs[i],
        }
      }
      var row = {
        index: idx,
        imgs: arr,
      }
      console.log(arr, 'arr=====================')
      this.$refs.preview.show(row)
    },
		getDept() {
				enableParent().then(res => {
				var data = []
				var data1 = {}
				res.rows.forEach(item => {
				 if(item.isCompany == 0) {
						if(data.length != 0) {
							data.forEach(item1 => {
							if(item1.deptId != item.deptId) {
								data1 = {
							         deptId: item.deptId,
							         title: item.deptName,
									 parentId: item.parentId
					          	}
							}

						})
						 data[data1.deptId] = data1
						}else {
						data1 = {
							         deptId: item.deptId,
							         title: item.deptName,
									  parentId: item.parentId
					          	}
						  data[data1.deptId] = data1
					}
					}
				})
				this.deptMap = data
			})

		},
        init(row) {
			this.getDept()
            if(row.arrive_time) {
					if (row.arrive_time.indexOf(" ") != -1) { 
				    row.arrive_time = row.arrive_time.split(' ')[0]
					}
				}
				if (row.purchase_time.indexOf(" ") != -1) { 
					row.purchase_time = row.purchase_time.split(' ')[0]
					}
            this.detailsrow = row
            var att_paths = []
			var cert_paths = []
				if (row.att_path) {
					var as = row.att_path.split(';')
					as.forEach((item) => {
						att_paths.push({
							name: item.split(',')[1],
							response: {
								data: item.split(',')[0],
							},
						})
					})
				}
				if (row.cert_path) {
					var as = row.cert_path.split(';')
					as.forEach((item) => {
						cert_paths.push({
							name: item.split(',')[1],
							response: {
								data: item.split(',')[0],
							},
						})
					})
				}
				this.detailsrow.att_paths = att_paths
				this.detailsrow.cert_paths = cert_paths
				this.detailsrow.pic_paths = row.pic_path ? row.pic_path.split(';') : []
                this.detailsvisible = true
  
        },
        //关闭弹窗
        detailsCancel() {
             this.detailsvisible = false
            
        },
        //预览文件
			previewFile(file) {
				console.log(file)
				window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
			},
    }

}
</script>

<style scoped>
/* .form_item {
		float: left;
		width: 50%;
		min-height: 50px;
		margin-bottom: 10px;
	} */

</style>